// Framework dependeices
import React, { Component } from 'react';
import anime from 'animejs/lib/anime.es.js';
// import * as $ from './jquery-3.5.1.min.js';

// Styling for this Object
import './EcoChains.css';
import './ScoreKeeper.css';

// Imports for this project
import Config from './Config'
import Helper from './Helper';

import Deck from './Deck';
import ScoreKeeper from './ScoreKeeper';
import IceColumn from './IceColumn';
import ApexCardSlot from './ApexCardSlot';
import CardModal from './CardModal';
import Card from './Card';

/*
    Pregame Setup:
        Shuffle deck
        Place Ice Cards

    Game steps:
        Draw a card
        Assess what kind of card it is
        (optional) Put the card in play
        Resolve card
        Draw next card

    Game ends when no more cards

    Cards go into a face-up pile and an out-of-play
    area. Not being able to play it right away means
    it goes face up and certain events knock cards
    out of play

    Need:
        - Something to manage current step in turn
        - Event handler
        - Card
        - Card pile locations
        - Play area
        - Data structure to read in to generate content

    Scoring:
        Species - 1 point per lifeform card

        Ice - * points per card in play that
                has an ice requirement where
                * is the ice requirement

        Bonus - Protected species and positive
                actions award victory points

    Action Cards
        - Sit in the play pile
        - Need a valid target in order to be played
        - This applies to negative events
        - Carbon pollution cards are the exception

    Apex Predators
        - Automatically find an open apex predator slot when drawn
*/

const STEP_DRAW_CARD = 1;
const STEP_ASSESS_CARD = 2;
const STEP_PLAY_CARD = 3;
const STEP_RESOLVE_CARD = 4;
const STEP_END_TURN = 5;

const DRAWN_CARD_INITIAL_POSITION = { x: 50, y: 10 };

const APEX_PREDATOR_SLOT_ID_ZERO = "apexCardSlot0"
const APEX_PREDATOR_SLOT_ID_ONE = "apexCardSlot1"
const APEX_PREDATOR_SLOT_ID_TWO = "apexCardSlot2"
const APEX_PREDATOR_SLOT_ID_THREE = "apexCardSlot3"

const CARBON_ICE_DESTRUCTION_AMOUNT = -2;

// used when putCadsInDrawDeck is called. Adjusts the height and width of stacked cards
const DECK_SIZE_MODIFIER = 2.5;

const OFFSET_FROM_ICE_CARD = 35;
const ICE_STACK_POSITION_MULTIPLIER = 38;
const MAGIC_NUMBER_OFFSET = 11;

const FADE_OUT_TIME = 1500;
const APEX_PRED_ANIMATION_DURATION = 2000

// Used for the fade out. A work around for poor object management and bashing anime into react without thinking about how the interaction is supposed to work
var __fadeOutFrameData = [];

export default class EcoChains extends Component {
    constructor () {
        super ();

        // When more difficulties get added, change this later
        let currentGameMode = Config.gameModes [0];

        // Create initial state
        this.state = {
            deck: Helper.clone (Config.decks [currentGameMode]),
            discard: [],
            predatoryMammals: [],
            targetCardIndex: -1,
            drawIndex: -1,
            faceUpPosition: DRAWN_CARD_INITIAL_POSITION,
            iceColumns: [
                { id: 'column0', children: [], ice: true },
                { id: 'column1', children: [], ice: true },
                { id: 'column2', children: [], ice: true },
                { id: 'column3', children: [], ice: true },
                { id: 'column4', children: [], ice: false },
                { id: 'column5', children: [], ice: false },
                { id: 'column6', children: [], ice: false },
            ],
            isDraggingCard: false,
            relativePosition: { x: 0, y: 0 },
            turnStep: 0,
            speciesScore: 0,
            iceScore: 0,
            bonusScore: 0,
            fedPredatorScoreBonus: {
                ice: 0,
                species: 0
            },
            cardParent: 'discard',
            drawnApexPredators: [],
            apexPredatorFoodChains: {
                zero: [],
                one: [],
                two: [],
                three: [],
            },
            outOfPlay: [],
            fadingOut: [],
            otherCardsBeingDragged: [],
            iceDestroyed: 0,
            uniqueSpeciesInPlay: {},
            cardToInspect: {},
            showInspectionModal: false,
            showEndGameScreen: false,
            showCreditsModal: false,
            showStopDrawCover: false,
            protectedSpeciesName: '',
            stopperCard: {},
            mouseX: 0,
            mouseY: 0,
            waitingToSpliceNullChildren: false,
            animatingCards: false,
            addIceRestoration: (Math.round (Math.random ())) ? true : false,
            addRapidSeaIceLoss: (Math.round (Math.random ())) ? true : false,
            debug: {
                forceExtraCardsOff: false,
                forceExtraCardsOn: false
            },
            shakingCards: false,
            hideHelpButton: false,
        }

        this._iceColumnDoms = [];

        // React is complaining about this but I literally cannot
        // setState before a component mounts
        this.state.deck.forEach (
            (card, index) => {
                this.state.deck [index] = Object.assign ({key: index}, card)
            }
        );

        let targetIndex = this.state.deck.length;
        let card;

        if (
            (this.state.addIceRestoration && this.state.debug.forceExtraCardsOff === false) ||
            this.state.debug.forceExtraCardsOn === true
        ) {
            card = Helper.clone (Config.cards.seaIceRestoration)
            card.key = targetIndex;
            this.state.deck [targetIndex] = card
        }
        if (
            (this.state.addRapidSeaIceLoss && this.state.debug.forceExtraCardsOff === false) ||
            this.state.debug.forceExtraCardsOn === true
        ) {
            card = Helper.clone (Config.cards.rapidSeaIceLoss)
            card.key = targetIndex + 1;
            this.state.deck [targetIndex + 1] = card
        }

        // Function binds to ensure reference to "this" exists
        this.flipAndMoveCard = this.flipAndMoveCard.bind (this);
        this.onMouseDownOnCard = this.onMouseDownOnCard.bind (this);
        this.onMouseUp = this.onMouseUp.bind (this);
        this.onMouseMove = this.onMouseMove.bind (this);
        this.createIceColumn = this.createIceColumn.bind (this);
        this.onDoubleclick = this.onDoubleClick.bind (this);
        this.closeModal = this.closeModal.bind (this);
        this.endGame = this.endGame.bind (this);
        this.showCredits = this.showCredits.bind (this);
        this.hideCredits = this.hideCredits.bind (this);

        // Global event listeners
        // document.body.addEventListener ('keydown', (event) => { this.handleKeyPress (event); })
        document.addEventListener ('mousemove', (event) => {
            this.onMouseMove (event)
         })
        document.addEventListener ('mouseup', (event) => {
            this.onMouseUp (event) })
        document.ondblclick = (event) => { this.onDoubleClick (event) }
    }

    // ---
    // ---
    // ---
//      Set up functions
    // ---
    // ---
    // ---

    async componentDidMount () {
        let board = Config.initialPlayAreas [
            Math.floor (Math.random () * Config.initialPlayAreas.length)
        ]

        await this.prepareDeck ();
        await this.shuffleCards ();
        await this.putCardsInDrawDeck ();

        window.setTimeout (async () => {
            console.clear ();
            console.log ('Clearing away linter warnings')
            await this.prepareBoard (board);
        }, 50);

        // Show loading screen at least for a little
        // To ENSURE that components are actually mounting. REACT
        anime ({
            targets: document.querySelector ('.loading-screen > .loader'),
            opacity: 0,
            easing: 'easeOutExpo',
            duration: 500,
            delay: 1500,
            complete: () => {
                try {
                    document.querySelector ('.loader').remove ();

                    let flavorText = document.createElement ('h1');
                    flavorText.innerHTML = Config.loadingScreenTextTitle;
                    flavorText.style = 'opacity: 0';

                    let flavorTextBody = document.createElement ('p');
                    flavorTextBody.innerHTML = Config.loadingScreenTextBody;
                    flavorTextBody.style = 'opacity: 0';

                    let button = document.createElement ('div');
                    button.classList.add ('loading-screen-button');
                    button.innerHTML = 'Play';
                    button.style = 'opacity: 0';

                    // let howToPlayButton = document.createElement ('div');
                    // howToPlayButton.classList.add ('loading-screen-button');
                    // howToPlayButton.classList.add ('how-to-play');
                    // howToPlayButton.innerHTML = 'How to Play';
                    // howToPlayButton.style = 'opacity: 0';
                    // howToPlayButton.addEventListener ('click', () => { window.open('https://etx-nec.s3-us-west-2.amazonaws.com/css/etx/projects/ecochains/how-to-play/index.html') })

                    button.onclick = () => {
                        // console.log ('here')
                        this.removeLoadingScreen ();
                    }

                    document.querySelector ('.loading-screen > .container').appendChild (flavorText);
                    document.querySelector ('.loading-screen > .container').appendChild (flavorTextBody);
                    document.querySelector ('.loading-screen > .container').appendChild (button);
                    // document.querySelector ('.loading-screen > .container').appendChild (howToPlayButton);

                    anime ({
                        targets: [flavorText, flavorTextBody, button],
                        opacity: 1,
                        easing: 'easeOutExpo',
                        duration: 500,
                    })
                }
                catch (error) {}

            }
        })
    }

    removeLoadingScreen () {
        anime ({
            targets: document.querySelector ('.loading-screen'),
            opacity: 0,
            easing: 'easeOutExpo',
            duration: 500,
            delay: 0,
            complete: () => {
                try {
                    document.querySelector ('.loading-screen').remove ();
                    let helpButton = document.querySelector ('.help-button');

                    anime ({
                        targets: [helpButton],
                        opacity: 1,
                        easing: 'easeOutExpo',
                        duration: 500,
                        delay: 0
                    })

                }
                catch (error) {}
            }
        })
    }

    prepareDeck () {
        return new Promise ( (resolve) => {
            this.setState ((prevState) => {
                // Add additional data to objects in deck
                let state = Helper.clone (prevState);
                let deck = [];

                // First, pull out the dummy card
                    /*
                        This needs to be done because of something weird with react that I don't understand.
                        For whatever reason, the for-each function call that happens just below skips the first
                        element of an array, but it works fine if that element is removed before the interaction.
                    */
                state.deck.splice (0, 1)

                // now prepare the deck as normal
                state.deck.forEach ( (card, index) => {
                    if (card && card.name) {
                        card.zIndex = this.state.deck.length - index + 10;
                        card.isFaceDown = true;
                        card.position = { x: 10, y: 10 };
                        card.isDiscard = false;
                        card.isPlacedInColumn = false;
                        card.id = Helper.replaceAll (card.name, ' ', '-') + index;
                        card.isProtected = false;

                        deck.push (card);
                    }
                });

                // console.log (deck [0])

                return { deck, turnStep: STEP_DRAW_CARD }
            }, () => { resolve (); });
        })
    }

    // iterate over given config cards for ice columns
    // and pre-set info
    prepareBoard (boardLayout) {
        return new Promise ((resolve) => {
            this.setState (
                (prevState) => {
                    let iceColumns = Helper.clone (prevState.iceColumns);

                    let item, key, list, index;
                    index = 0;
                    list = boardLayout

                    // iceColumns = this.injectStartLayout ()
                    for (key in list) {
                        let item = list [key];

                        let targetColumn = iceColumns [index]


                        let cards = this.prepareCards (item, targetColumn.id);

                        targetColumn.children = targetColumn.children.concat (cards);

                        index++;
                    }

                    // console.log ('IceColumns', iceColumns)

                    return { iceColumns }
                },
                async () => {
                    // Run the previously established cards through the various functions to make them think they need to go back to their columns
                    await this.realignCards ();
                }
            )
        })
    }

    realignCards () {
        return new Promise ((resolve) => {
            this.setState (
                (prevState) => {
                    let state = Helper.clone (prevState)
                    let list = state.iceColumns;
                    let item, key, colIndex = 0;
                    for (key in list) {
                        item = list [key];

                        let subList = item.children;
                        let subItem, subKey;
                        let cardIndex = 0;
                        for (subKey in subList) {
                            subItem = subList [subKey];

                            subItem.position = {
                                x: -55,
                                y: (ICE_STACK_POSITION_MULTIPLIER * cardIndex) + OFFSET_FROM_ICE_CARD
                            }
                            cardIndex++
                        }
                        colIndex++
                        // item.children.forEach (async (card, index) => {
                        //     console.log ('setting', item.id, index, colIndex)
                        // })

                    }

                    return {iceColumns: list}
                },
                () => { resolve (); }
            )
        })
    }

    prepareCards (cards, columnId) {
        let list = Helper.clone (cards);

        if (columnId === undefined) { columnId = '' }

        list.forEach ((card, cardIndex) => {
            card.zIndex = cardIndex;
            card.isFaceDown = false;
            card.position = { x: 0, y: 0 };
            card.isDiscard = true;
            card.isPlacedInColumn = columnId;
            card.id = Helper.replaceAll (card.name, ' ', '-') + cardIndex + columnId;
            card.isProtected = false;

            if (!('footer' in card)) { card.footer = ''; }
            if (!('blockerText' in card)) { card.blockerText = ''; }
            if (!('validTargets' in card)) { card.validTargets = []; }
            if (!('diet' in card)) { card.diet = []; }

            // console.log (card)

            list [cardIndex] = card;
        })

        return list
    }

    // Organize cards into top left corner and create a cool little stacking effect
    putCardsInDrawDeck () {
        return new Promise ( (resolve) => {
            this.setState ( (prevState) => {
                // start from the bottom of the deck and go backwards
                let offset;
                let deck = Helper.clone (prevState.deck)

                deck.forEach ( (card, index) => {
                    offset = index / DECK_SIZE_MODIFIER;

                    card.position = { x: 0, y: offset}
                    card.isFaceDown = true;
                    card.zIndex = deck.length - index;
                })
                return { deck }
            }, () => { resolve (); })
        })
    }

    // Randomize array of cards and adjust z-index accordingly
    shuffleCards () {
        // Re-arrange card array
        return new Promise ( (resolve) => {

            this.setState (
                (prevState) => {
                    // Randomize orderof cards
                    let deck = Helper.clone (prevState.deck);
                    Helper.shuffle (deck);
                    return { deck }
                },
                () => {
                    // Assign new z-index but only if card is not in a column or in the discard pile
                    // by modifying a clone of the deck array
                    let deck = Helper.clone (this.state.deck);

                    // Modify data on the clone
                    deck.forEach ( (card, index) => {
                        let canShuffle = (card.isPlacedInColumn === false && card.isDiscarded === false);

                        if (canShuffle) { card.zIndex = this.state.deck.length - index }
                    })

                    // Resolve when state change is done
                    this.setState ( () => { return {deck} }, () => { resolve (); } )
                }
            )
        });
    }

    // ---
    // ---
    // ---
    // ---
//      Runtime functions
    // ---
    // ---
    // ---

    // Called whenever a setState function finishes
    componentDidUpdate (prevProps, prevState, snapshot) {
        if (prevState.turnStep !== this.state.turnStep) {
            // We've moved to the next part of the turn
            let currentStep = this.state.turnStep
            switch (currentStep) {
                case STEP_DRAW_CARD: // Draw a new card
                    // console.log ('Drawing a card');
                    break;
                case STEP_ASSESS_CARD: // Player is reviewing card
                    // console.log ('Assessing card');
                    break;
                case STEP_PLAY_CARD: // Depends on card type
                    // console.log ('Playing card');
                    break;
                case STEP_RESOLVE_CARD: // After-play affects of card
                    // console.log ('Resolving card');
                    break;
                case STEP_END_TURN: // Do stuff to prepare for next round?
                    // console.log ('Turn end events');
                    break;
                default:
                    // We've iterated passed possible steps
                    // start new turn
                    console.log ('New turn');
                    this.setState ({ turnStep: STEP_DRAW_CARD })
            }
        }

        // Iterate over our columns and check how many of them are ice
        let iceCount = 0;
        let uniqueNames = {};

        this.state.iceColumns.forEach ((column) => {
            if (column.ice === true) { iceCount++ }

            // iterate over children in columns to get names of unique species
            column.children.forEach ((species) => {
                uniqueNames [species.name] = true;
            })
        })

        let update = {}

        // iterate over fed predators and count the ice in them
        let predatorIceScore = 0;
        this.state.apexPredatorFoodChains.zero.forEach ((card) => {
            predatorIceScore += card.needsIce
        })
        this.state.apexPredatorFoodChains.one.forEach ((card) => {
            predatorIceScore += card.needsIce
        })
        this.state.apexPredatorFoodChains.two.forEach ((card) => {
            predatorIceScore += card.needsIce
        })
        this.state.apexPredatorFoodChains.three.forEach ((card) => {
            predatorIceScore += card.needsIce
        })

        if ((iceCount + predatorIceScore) !== this.state.iceScore) {
            update.iceScore = iceCount + predatorIceScore
        }

        let fedScore = this.state.apexPredatorFoodChains.zero.length + this.state.apexPredatorFoodChains.one.length + this.state.apexPredatorFoodChains.two.length + this.state.apexPredatorFoodChains.three.length

        if ((Object.keys (uniqueNames).length + fedScore) !== this.state.speciesScore) {
            update.uniqueSpeciesInPlay = uniqueNames
            update.speciesScore = Object.keys (this.state.uniqueSpeciesInPlay).length
            update.speciesScore += fedScore;
        }

        if (Object.keys (update).length) {
            this.setState (update)
        }
    }

    makeSureCardsBelongToCorrectColumn () {
        return new Promise ((resolve) => {
            this.setState ((prevState) => {
                let state = Helper.clone (prevState);
                let iceColumns = state.iceColumns;

                // console.clear ()
                iceColumns.forEach ((column, index) => {
                    let clearColumn = false;
                    // console.log ('Checking', column.id, 'which is ice?', column.ice)
                    column.children.forEach ((card) => {
                        // console.log ('Checking', card.name, 'which requires', card.needsIce, 'ice')
                        card.isPlaceInColumn = column.id

                        if (
                            (card.name === Config.cards.phytoPlankton.name && column.ice) ||
                            (card.name === Config.cards.iceAlgea.name && !column.ice)
                        ) {
                            console.log ('Clearing column')
                            clearColumn = true;
                        }
                    })

                    if (clearColumn) {
                        let cardsToFadeOut = Helper.clone (iceColumns [index].children);
                        iceColumns [index].children = [];

                        cardsToFadeOut.forEach ((card) => {
                            this.fadeOutCardOutOfPlay (card)
                        })
                    }
                })

                return {iceColumns};
            })
        })
    }

    // Makes whatever card is being dragged render on top of
    // every other card
    bringCardToFront () {
        return new Promise ( async (resolve) => {
            await this.sortIceColumnsZIndex ();

            this.setState (
                (prevState) => {
                    let discard = Helper.clone (prevState.discard);
                    let iceColumns = Helper.clone (prevState.iceColumns);
                    let cardParent = prevState.cardParent;
                    let targetCardIndex = prevState.targetCardIndex;

                    // This will probably make things look weird later, keep an eye on it
                    // console.warn ('Running possibly flawed z-ordering operation');
                    discard.forEach ((card, index) => {
                        card.zIndex = discard.length - index;
                    });

                    // Make sure we are even dragging a card;
                    let targetCard = this.findCard ();
                    if (targetCard) {
                        // Check where the card was before we started dragging it
                        switch (cardParent) {
                            case 'discard': discard [targetCardIndex].zIndex = 100; break;
                            default:
                                let columnIndex = Number (cardParent.split ('column') [1])
                                let foundCard = false;

                                console.log ('here?', columnIndex)
                                iceColumns [columnIndex].children.forEach ((card, index) => {
                                    if (card.id === targetCard.id) {
                                        foundCard = true
                                    }

                                    if (foundCard) {
                                        iceColumns [columnIndex].children [index].zIndex = 1000 + index
                                    }

                                })
                        }
                    }


                    return { discard, iceColumns }
                },
                () => { resolve (); }
            )
        })
    }

    // Makes sure every card renders correctly in ice columns
    sortIceColumnsZIndex () {
        return new Promise ( (resolve) => {
            this.setState (
                (prevState) => {
                    let state = Helper.clone (prevState);
                    let iceColumns = state.iceColumns

                    iceColumns.forEach ((column) => {
                        column.children.forEach (( child, index ) => {
                            child.zIndex = index;
                            column [index] = child;
                        })
                    })

                    return { iceColumns }
                },
                () => { resolve (); }
            )
        })
    }

    flipCard (cardIndex) {
        return new Promise ( (resolve) => {
            this.setState (
                (prevState) => {
                    let deck = Helper.clone (prevState.deck);
                    deck [cardIndex].isFaceDown = !deck [cardIndex].isFaceDown;
                    return { deck };
                },
                () => { resolve (); })
        })
    }

    incrementTurnStep () {
        return new Promise ( (resolve) => {
            this.setState ((prevState) => { return { turnStep: prevState.turnStep + 1 } }, () => { resolve (); })
        })
    }

    async flipAndMoveCard (event) {
        // if (this.state.turnStep !== STEP_DRAW_CARD) { return; }

        let deckDom = document.querySelector ('div.deck.Draw > .event-holder')
        let target = event.target;

        // If the deck is not what was clicked, don't do anything
        if (deckDom !== target) { return; }

        // If we can't draw a card, reshuffle any cards not placed
        // back into the draw deck and randomize the deck

        // await this.incrementDrawIndex ();

        let validIndex = this.state.deck [this.state.deck.length - 1];

        if (validIndex === undefined) {
            console.log ('end game')
            return;
        }

        let index = this.state.deck.length - 1;

        await new Promise ( (resolve) => {
            this.setState ({drawIndex: index}, () => { resolve (); })
        })

        await this.flipCard (index);

        let card = validIndex;
        let cardDom = document.getElementById (card.id);

        // console.log ('getting card:', card.id, cardDom)

        let cardWidth = cardDom.getBoundingClientRect ().width;

        switch (validIndex.type) {
            case Config.types.lifeform:
                // console.log ('This card is a lifeform');
                break;
            case Config.types.worldEvent:
                // console.log ('This card is a world event');

                let carbonPollution = Config.cards.carbonPollution.name;
                let rapidSeaIceLoss = Config.cards.rapidSeaIceLoss.name;

                switch (card.name) {
                    case rapidSeaIceLoss:
                    case carbonPollution:
                        let iceAmount = this.checkIceAmount (this.state.iceColumns);

                        if (iceAmount > 0) {
                            this.setState ({
                                showStopDrawCover: true,
                                stopperCard: card
                            })
                        }
                        break;
                    default:
                        window.setTimeout (() => {
                            let validTargetsAvailable = this.checkValidTargetForEvent (card);

                            if (validTargetsAvailable) {
                                this.setState ({
                                    showStopDrawCover: true,
                                    stopperCard: card
                                })
                            }

                        }, 10)
                }

                break;
            case Config.types.apexPredator:
                // console.log ('This card is an apex predator');
                // console.log ('moving card into an open apex predator slot');
                this.moveApexPredatorToSlot (index, cardDom);

                return;
            default:
                console.log ('Uuuuuuh?');
                break;
        }

        let position = {
            x: -cardWidth / 2,
            y: 0
        }

        await this.moveCardToDiscard (index, position);
        await this.bringCardToFront (0);
        await this.incrementTurnStep ();
    }

    moveApexPredatorToSlot (i, cardDom) {
        let cardBoundsUnderOldParent = cardDom.getBoundingClientRect ();
        let index = i;

        this.setState ((prevState) => {
            let state = Helper.clone (prevState);
            let deck = state.deck;
            let drawnApexPredators = state.drawnApexPredators
            let newParentRect = document.getElementById ('apexCardSlot' + state.drawnApexPredators.length)

            // apex predator cards never leave the deck until this point
            // so just assume the parent
            //splice card out of deck and into the drawnApexPredators list
            let card = deck.splice (index, 1) [0];

            // card.position.x = cardBoundsUnderOldParent.x - newParentRect.x;
            // card.position.y = cardBoundsUnderOldParent.y - newParentRect.y;

            let deckX = document.querySelector ('.deck.Draw').getBoundingClientRect ().left;
            let predX = document.getElementById ('apexCardSlot' + drawnApexPredators.length).getBoundingClientRect ().left;

            card.position.x = Math.hypot (deckX - predX, 0) * -1;
            card.position.y = 0;
            card.isFaceDown = false;

            drawnApexPredators.push (card);

            let destinationX = -cardBoundsUnderOldParent.width/2;
            let destinationY = 0;

            this.setState ({ deck }, () => {
                anime ({
                    targets: card.position,
                    x: destinationX,
                    y: destinationY,
                    easing: 'easeInOutExpo',
                    duration: APEX_PRED_ANIMATION_DURATION,
                    // easing: 'easeOutElastic(1, .8)',
                    update: () => {
                        card.zIndex = 1100;
                        console.log (drawnApexPredators [0].zIndex);
                        this.setState ({ drawnApexPredators, animatingCards: true, showStopDrawCover: true, stopperCard: { blockerText: ' ', id:'apex-tracker-card' } });
                    },
                    complete: () => {
                        card.zIndex = 0;
                        this.setState ({ drawnApexPredators, animatingCards: false, showStopDrawCover: false, stopperCard: {} });
                    }
                })
            })
        })
    }

    incrementDrawIndex () {
        return new Promise ( (resolve) => {
            this.setState (
                (prevState) => {
                    let validIndex = prevState.deck [prevState.drawIndex + 1];
                    let drawIndex;

                    if (validIndex) { drawIndex = prevState.drawIndex + 1; }
                    else { drawIndex = -1; }

                    return { drawIndex }
                },
                () => { resolve (); }
            );
        })
    }

    moveCardToDiscard (cardIndex, position) {
        return new Promise ( (resolve) => {
            this.setState (
                (prevState) => {
                    // Pull the card out of the deck and move it to the discard
                    let deck = Helper.clone (prevState.deck);
                    let discard = Helper.clone (prevState.discard);

                    let card = deck.splice (cardIndex, 1) [0];

                    card.position = position;

                    discard.unshift ( card );

                    // console.log (card)

                    return { deck, discard };
                },
                () => { resolve (); })
        })
    }

    // This only works on cards already in the discard pile
    // NOTE: The discard pile is really the play pile.
    // This is just due to poor planning
    sendBackToDiscard () {
        let discard = Helper.clone (this.state.discard);
        let cardIndex = this.state.targetCardIndex;

        anime ({
            targets: discard [cardIndex].position,
            // this is negative of half the width of a card
            x: -53,
            y: 0,
            easing: 'easeOutExpo',
            duration: 300,
            loop: false,
            update: () => {
                this.setState ({ discard });
            },
            complete: () => {
                this.setState ({ animatingCards: false })
            }
        })
    }

    sendBackToIceColumn (dur, iceCol, crdParent, crdIndex, iceColIndex) {
        return new Promise ((resolve) => {
            // I should just figure out how to use destructured parameters here, but I am stressed for time
            let duration = dur;
            let iceColumns = iceCol;
            let cardParent = crdParent;
            let cardIndex = crdIndex

            if (duration === undefined) { duration = 300; }
            if (iceColumns === undefined) {
                iceColumns = Helper.clone (this.state.iceColumns);
            }
            if (cardParent === undefined) {
                cardParent = Helper.clone (this.state.cardParent);
            }
            if (cardIndex === undefined) {
                cardIndex = this.state.targetCardIndex;
            }

            let iceColumnIndex = iceColIndex;

            if (iceColumnIndex === undefined) {
                iceColumns.forEach ( (column, index) => {
                    if (column.id === cardParent) { iceColumnIndex = index }
                })
            }

            console.log ('Returning card', duration, iceColumns, cardParent, cardIndex, iceColumnIndex)

            anime ({
                targets: iceColumns [iceColumnIndex].children [cardIndex].position,
                // this is negative of half the width of a card
                x: -55,
                y: (ICE_STACK_POSITION_MULTIPLIER * cardIndex) + OFFSET_FROM_ICE_CARD,
                easing: 'easeOutExpo',
                duration,
                loop: false,
                update: () => {
                    console.log ('Animating cards?', this.state.animatingCards)
                    if (this.state.otherCardsBeingDragged.length === 0) {
                        this.setState ({ iceColumns });
                    }
                    else {
                        this.setState ((prevState) => {
                            // find what column has this card
                            let mainCard = iceColumns [iceColumnIndex].children [prevState.targetCardIndex]
                            let column, columnIndex;

                            iceColumns.forEach ((col, index) => {
                                if (col.id === prevState.cardParent) {
                                    column = col;
                                    columnIndex = index;
                                }
                            })

                            // Iterate over other cards being moved and set
                            // their position too.
                            // We already know they belong to the same column
                            // Set the position of the other cards being dragged
                            // relative to the moved card
                            prevState.otherCardsBeingDragged.forEach ( (cardIndex) => {
                                let otherCard = iceColumns [columnIndex].children [cardIndex]

                                otherCard.position.x = mainCard.position.x
                                otherCard.position.y = mainCard.position.y + (ICE_STACK_POSITION_MULTIPLIER * (cardIndex -prevState.targetCardIndex))

                                // console.log (cardIndex, otherCard.position)

                                iceColumns [columnIndex].children [cardIndex] = otherCard
                            })

                            return { iceColumns }
                        })
                    }
                },
                complete: () => {
                    this.setState (
                        { otherCardsBeingDragged: [], animatingCards: false },
                        async () => {
                            await this.realignCards ();
                            resolve ();
                        }
                    )
                }
            })
        })

    }

    closeModal () { this.setState ({showInspectionModal: false}) }

    changeIceAmount (modifier, iceColumns) {
        let currentIceAmount = this.checkIceAmount (iceColumns);
        let modified = 0;

        // Set ice to true on water cards next to ice cards
        if (modifier > 0) {
            // iterating from left to right
            iceColumns.forEach ((column) => {
                if (
                    column.ice === false &&
                    modified < Math.abs (modifier)
                ) {
                    column.ice = true;
                    modified++;
                }
            })
        }
        // Set ice to false on ice cards next to water cards
        else if (modifier < 0) {
            // iterating from right to left
            let i = iceColumns.length - 1;
            let start = 0;

            while (i >= start) {
                let column = iceColumns [i];

                if (
                    column.ice === true &&
                    modified < Math.abs (modifier)
                ) {
                    column.ice = false;
                    modified++;
                }

                i--
            }
        }

        return iceColumns
    }

    endGame () { this.setState ({ showEndGameScreen: true }) }
    showCredits () { this.setState ({ showCreditsScreen: true }) }
    hideCredits () { this.setState ({ showCreditsScreen: false }) }

    newGame () { window.location.reload (); }

    // ---
    // ---
    // ---
//      Mouse Event Handlers
    // ---
    // ---
    // ---

    onDoubleClick (event) {
        if (this.state.showInspectionModal) { return; }

        console.log ('double click detected. Target:', event)
        console.log ('looking for', this.state.cardToInspect.id)
        let cardDom = document.getElementById (this.state.cardToInspect.id);

        console.log ('Found element?', cardDom)

        if (!cardDom) { return }

        let targetInCard = cardDom.contains (event.target);

        if (targetInCard) {
            this.setState ({ showInspectionModal: true })
        }
    }

    onMouseMove (event) {
        if (!this.state.isDraggingCard) { return }

        let position = {
            x: event.pageX - this.state.relativePosition.x,
            y: event.pageY - this.state.relativePosition.y
        }

        this.setState ((prevState) => {
            if (prevState.cardParent === 'discard') {
                let discard = Helper.clone (prevState.discard);

                discard [prevState.targetCardIndex].position = position

                return { discard }
            }
            else {
                // find what column has this card
                let iceColumns = Helper.clone (prevState.iceColumns);

                let column, columnIndex;

                iceColumns.forEach ((col, index) => {
                    if (col.id === prevState.cardParent) {
                        column = col;
                        columnIndex = index;
                    }
                })

                // console.log (column.id);
                // console.log (column.children);
                // console.log (prevState.targetCardIndex);

                // Just don't do anything if information is missing
                if (
                    !column ||
                    !column.children ||
                    !column.children [prevState.targetCardIndex]
                ) { return; }

                column.children [prevState.targetCardIndex].position = position;

                // Iterate over other cards being moved and set
                // their position too.
                // We already know they belong to the same column
                if (prevState.otherCardsBeingDragged.length > 0) {
                    // Set the position of the other cards being dragged
                    // relative to the moved card

                    prevState.otherCardsBeingDragged.forEach ( (cardIndex) => {
                        let otherCard = iceColumns [columnIndex].children [cardIndex]

                        otherCard.position.x = position.x
                        otherCard.position.y = position.y + (ICE_STACK_POSITION_MULTIPLIER * (cardIndex -prevState.targetCardIndex))

                        iceColumns [columnIndex].children [cardIndex] = otherCard
                    })
                }

                iceColumns [columnIndex] = column;

                return { iceColumns, mouseX: event.pageX, mouseY: event.pageY }
            }
        })

        event.stopPropagation ()
        event.preventDefault ()
    }

    // calculate relative position to the mouse and set dragging=true
    onMouseDownOnCard ({ event, card }) {
        // Don't do anything if cards are moving
        console.log ('Animating a card?', this.state.animatingCards)
        if (this.state.animatingCards === true) { return; }

        let target = event.target;
        let isFaceDown = target.classList.contains ('facedown');
        let isIce = target.classList.contains ('ice');
        let isAlgea = target.classList.contains ('algea');
        let isPredator = (card.type === Config.types.apexPredator);
        let otherCardsBeingDragged = [];
        let cardType = card.type;

        // Make sure the card isn't facedown
        if (isFaceDown) { return; }

        // Make sure this card isn't one of the ice cards
        if (isIce && !isAlgea) { return; }

        // Don't do anything if a predator was click
        if (isPredator) {
            this.setState ({
                cardToInspect: card
            })
            return;
        }

        let pos = Helper.clone (card.position);

        // Assume the discard pile is the parent
        let cardParent = 'discard';

        // then check if the card is placed in a column
        if (card.isPlacedInColumn) { cardParent = card.isPlacedInColumn }

        if (cardType === Config.types.worldEvent) {
            //Iterate over cards that match the diet
            // this.applyScaredClassToCards (card)
        }

        this.setState({
            cardParent, otherCardsBeingDragged,
            isDraggingCard: true,
            targetCardIndex: card.index,
            relativePosition: {
                x: event.pageX - pos.x,
                y: event.pageY - pos.y
            },
            cardToInspect: card
        }, async () => {
            // If the target is an apex predator, stop dragging from
            // happening
            console.log (this.state.targetCardIndex);

            // Make sure we are dragging a card befre we check
            // for other cards that need to be dragged
            if (!this.state.isDraggingCard) { return }

            await this.bringCardToFront ();

            this.setState ((prevState) => {
                let state = Helper.clone (prevState);
                let card = this.findCard (prevState);
                let iceColumns = state.iceColumns;
                let cardParent = state.cardParent;
                let otherCardsBeingDragged = state.otherCardsBeingDragged;
                let cardIndex = state.targetCardIndex;

                // Check that column to see if the card grabbed
                // is not the top of the stack
                if (cardParent !== 'discard') {
                    iceColumns.forEach ((column, index) => {
                        if (
                            column.id === cardParent &&
                            cardIndex < (column.children.length - 1)
                        ) {
                            // Grab every card after this card too
                            column.children.forEach  ( (child, index) => {
                                if (cardIndex < index) {
                                    // We only need the indexes
                                    // of the other cards
                                    otherCardsBeingDragged.push (index)
                                }
                            })
                        }
                    })

                    return { iceColumns, otherCardsBeingDragged }
                }

                // Don't update state if we are pulling a card
                // from the discard pile
                return {}
            })

        })

        event.stopPropagation ();
        event.preventDefault ();
    }

    onMouseUp (event) {
        // console.log ('Dragging card?', this.state.isDraggingCard)

        if (this.state.shakingCards) {
            // this.applyScaredClassToCards (null, true)
        }

        if (this.state.isDraggingCard) {
            this.setState ({ animatingCards: true })

            let validDrop = false;

            validDrop = this.checkIfCardCanGoInColumn ();

            console.log ('Valid drop?', validDrop)

            // Have to use "crd" instead of "card" here
            // because this app is poorly planned around
            // how react wants things done
            let crd = this.findCard ();

            if (validDrop && crd.type === Config.types.lifeform) {
                // look through the column that this card
                // is about to be dropped in to make sure
                // it can go ontop of the possible other
                // cards that go in there
                let result = this.checkIfSpeciesCanGoInColumn (
                    crd,
                    this.state.iceColumns [validDrop.iceColumnIndex]
                )

                if (!result) { validDrop = null }
            }

            // Up to this point, we are only checking if the
            // player tried to put a card in an ice column
            if (!validDrop) {
                // Now check if the player tried to feed an apex predator
                let feedingPredator = this.checkIfFeedingPredator (crd, event)
                let canFeedPredator = false;

                if (feedingPredator && feedingPredator.closestCollision) {
                    let key = Object.keys (this.state.apexPredatorFoodChains) [feedingPredator.colIndex];

                    if (this.state.apexPredatorFoodChains [key].length === 0) {
                        canFeedPredator = true
                    }
                }

                // First check to see if we are dragging the whole column before moving on
                let parentColumn;
                this.state.iceColumns.forEach ((col) => { if (col.id === this.state.cardParent) { parentColumn = col } })

                // console.log ('Dragging:', this.state.otherCardsBeingDragged, 'ice column children:', parentColumn.children)


                // let draggedCardCount = this.state.otherCardsBeingDragged.length + 1;
                // // console.log ('Amount of cards being dragged:', draggedCardCount)
                // // console.log ('Amount of children ice column has:', parentColumn.children.length)
                // if (!parentColumn || draggedCardCount != parentColumn.children.length) {
                //     canFeedPredator = false;
                // }

                // Now feed the predator if we can
                if (canFeedPredator &&  this.state.cardParent != 'discard') {
                    this.setState ((prevState) => {
                        let state = Helper.clone (prevState);
                        let apexPredatorFoodChains = state.apexPredatorFoodChains
                        let iceColumns = state.iceColumns;

                        let column
                        state.iceColumns.forEach ((col) => { if (col.id === state.cardParent) { column = col; } })

                        // Check if we have the full stack
                        let draggedCardCount = state.otherCardsBeingDragged.length + 1;
                        let draggingPartialStack = false;


                        if (draggedCardCount !== column.children.length) { draggingPartialStack = true }

                        // Take cards from column
                        let otherCards = column.children.splice (0, column.children.length)

                        // splice card out of prev parent
                        // let oldParent = iceColumns [ Number (state.cardParent.split ('column') [1]) ]

                        // let card = oldParent.children.splice (state.targetCardIndex, 1) [0];
                        // let otherCards = [];

                        // otherCards.push (card);

                        // Move the other cards into this new parent
                        // if (state.otherCardsBeingDragged.length > 0) {
                            // Collect the data of the other cards
                            // otherCards.forEach ( (otherCard, index) => {
                            //     if (index )
                            //     otherCards.push (
                            //         // Subtract 1 since the dragged card was
                            //         // already spliced out
                            //         Helper.clone (otherCards [index])
                            //     )
                            // })

                        // }

                        let key = Object.keys (apexPredatorFoodChains) [feedingPredator.colIndex]

                        apexPredatorFoodChains [key] = otherCards

                        let colX = document.getElementById (state.cardParent).getBoundingClientRect ().left;

                        let predIndex = 0;

                        let item, k;
                        for (k in apexPredatorFoodChains) {
                            item = apexPredatorFoodChains [k];

                            if (k === key) { break; }

                            predIndex++;
                        }

                        let predRect = document.getElementById ('apexCardSlot' + predIndex).getBoundingClientRect ();
                        let predX = predRect.left;

                        // console.log (otherCards, apexPredatorFoodChains)
                        let newPos = { x: Math.hypot (colX - predX, 0) * -1, y: 0 }

                        if (draggingPartialStack) {
                            window.setTimeout (() => {
                                anime ({
                                    targets: [newPos],
                                    x: -(predRect.width / 2) + 12,
                                    y: 0,
                                    easing: 'easeOutExpo',
                                    duration: 1500,
                                    update: () => {
                                        this.setState ((prevState) => {
                                            let state = Helper.clone (prevState);
                                            let apexPredatorFoodChains = state.apexPredatorFoodChains;

                                            apexPredatorFoodChains [key].forEach ((card, index) => {
                                                apexPredatorFoodChains [key] [index].position.x = newPos.x
                                            })

                                            console.log ('updating cards to', newPos.x, apexPredatorFoodChains [key] [0].position.x)

                                            return { apexPredatorFoodChains }
                                        })
                                    },
                                    complete: () => {
                                        this.setState ({ animatingCards: false })
                                    }
                                })
                            })
                            return {iceColumns, apexPredatorFoodChains, animatingCards: true}
                        }
                        else {
                            apexPredatorFoodChains [key].forEach ((card, index) => {
                                apexPredatorFoodChains [key] [index].position.x = -(predRect.width / 2) + 12
                            })
                        }

                        return {iceColumns, apexPredatorFoodChains, animatingCards: false}
                    }, () => {
                        console.log ('Top card on discard', this.state.discard [0])
                        console.log ('Stopper card?', this.state.stopperCard)
                        if (this.state.showStopDrawCover) {
                            let topCard = this.state.discard [0];
                            // re-check ice columns for valid targets
                            let validTargetsAvailable = this.checkValidTargetForEvent (topCard);

                            console.log ('found valid targets?', validTargetsAvailable)

                            if (!validTargetsAvailable) {
                                this.setState ({ showStopDrawCover: false })
                            }
                        }
                    })
                }
                else {
                    // if not, put things back
                    if (this.state.cardParent === 'discard') { this.sendBackToDiscard (); }
                    else { this.sendBackToIceColumn (); }
                }
            }
            else {
                // Move card into that column
                this.setState (async (prevState) => {
                    let state = Helper.clone (prevState);
                    let iceColumns = state.iceColumns;
                    let cardIndex = state.targetCardIndex;
                    let index = validDrop.iceColumnIndex;

                    let discard = state.discard

                    let targets;
                    let newParent;

                    let card = this.findCard ();
                    let otherCards = [];

                    if (card.type === Config.types.lifeform) {
                        // The card needs to spliced out of any arrays so its
                        // position is absolute and it doesn't mess with
                        // calculations related to children count
                        if (state.cardParent === 'discard') {
                            card = discard.splice (cardIndex, 1) [0];
                        }
                        else {
                            let oldParent = state.iceColumns [ Number (state.cardParent.split ('column') [1]) ]

                            card = oldParent.children.splice (cardIndex, 1) [0];

                            // Move the other cards into this new parent
                            if (state.otherCardsBeingDragged.length > 0) {
                                // Collect the data of the other cards
                                state.otherCardsBeingDragged.forEach ( (otherCardIndex) => {
                                    otherCards.push (
                                        // Subtract 1 since the dragged card was
                                        // already spliced out
                                        Helper.clone (oldParent.children [otherCardIndex - 1])
                                    )
                                })

                                oldParent.children.splice (cardIndex, oldParent.children.length)
                            }
                        }

                        targets = card.position;

                        let cardDom = document.getElementById (card.id);
                        let cardBoundsUnderOldParent = cardDom.getBoundingClientRect ();

                        // The new parent can only ever be an ice column
                        newParent = iceColumns [index].children;

                        // console.log ('moving', card, 'to', JSON.stringify (newParent, null, 4))
                        card.isPlacedInColumn = iceColumns [index].id;
                        newParent.push (card);

                        // Push the other cards being dragged if there are any
                        if (otherCards.length > 0) {
                            // console.log ('Also moving these cards:', JSON.stringify (otherCards, null, 4))

                            let startIndex = newParent.length - 1;

                            otherCards.forEach ((otherCard) => {
                                otherCard.isPlacedInColumn = iceColumns [index].id;
                                newParent.push (otherCard)
                            })

                            state.otherCardsBeingDragged = [];
                            otherCards.forEach ((item, index) => {
                                // item.isPlacedInColumn = iceColumns [index].id;
                                state.otherCardsBeingDragged.push (index + startIndex);
                            })
                        }

                        iceColumns [index].children = newParent;

                        let newParentDom = document.getElementById (iceColumns [index].id);
                        let newParentRect = newParentDom.getBoundingClientRect ();

                        targets.x = cardBoundsUnderOldParent.x - newParentRect.x;
                        targets.y = cardBoundsUnderOldParent.y - newParentRect.y;

                        let destinationX = 0 - (validDrop.cardWidth/2) - 5;
                        let destinationY = ((ICE_STACK_POSITION_MULTIPLIER + MAGIC_NUMBER_OFFSET) * (newParent.length - otherCards.length)) - OFFSET_FROM_ICE_CARD;

                        // Animate card into position
                        anime ({
                            targets,
                            x: destinationX,
                            y: destinationY,
                            easing: 'easeOutExpo',
                            duration: 300,
                            loop: false,
                            update: async () => {
                                if (state.otherCardsBeingDragged.length === 0) {
                                    this.setState ({ discard, iceColumns });
                                }
                                else {
                                    this.setState (async (prevState) => {
                                        let state = Helper.clone (prevState);

                                        // console.log ('Grabbing a card from', state.iceColumns [index].children)

                                        // The children have somehow already moved
                                        if (state.iceColumns [index].children.length === 0) {
                                            return { discard, iceColumns }
                                        }

                                        // find what column has this card
                                        let mainCard = state.iceColumns [index].children [state.targetCardIndex]

                                        // If this is undefined, grab the base card.
                                        if (mainCard === undefined) {
                                            mainCard = state.iceColumns [index].children [0]
                                        }

                                        // Iterate over other cards being moved and set
                                        // their position too.
                                        // We already know they belong to the same column
                                        // Set the position of the other cards being dragged
                                        // relative to the moved card
                                        state.otherCardsBeingDragged.forEach ( (cardIndex) => {
                                            // console.log (iceColumns, index)
                                            let otherCard = iceColumns [index].children [cardIndex]

                                            // console.log (otherCard)

                                            otherCard.position.x = mainCard.position.x + 4
                                            otherCard.position.y = mainCard.position.y + (ICE_STACK_POSITION_MULTIPLIER * cardIndex)

                                            // console.log (cardIndex, otherCard.position)

                                            iceColumns [index].children [cardIndex] = otherCard
                                        })

                                        return { iceColumns, discard }
                                    }, () => { this.makeSureCardsBelongToCorrectColumn (); })
                                }
                            },
                            complete: () => {

                                card.position.x = -validDrop.cardWidth / 2;
                                card.position.y = destinationY;

                                this.setState (
                                    {
                                        iceColumns,
                                        discard,
                                        turnStep: STEP_DRAW_CARD,
                                        otherCardsBeingDragged: [],
                                        animatingCards: false
                                    },
                                    async () => {
                                        await this.sortIceColumnsZIndex ();
                                        // console.log (targets, destinationX, destinationY)
                                        await this.realignCards ();
                                        await this.makeSureCardsBelongToCorrectColumn ();
                                    }
                                )
                            }
                        })

                        return { iceColumns, discard }
                    }
                    else if (
                        card.type === Config.types.worldEvent ||
                        card.type === Config.types.action
                    ) {
                        let resolution = card.resolution;
                        let iceColumn = iceColumns [validDrop.iceColumnIndex]
                        let outOfPlay = state.outOfPlay;
                        let result;
                        let animatingCards = false;

                        switch (resolution) {
                            case Config.resolutions.removeIce:
                            case Config.resolutions.rapidSeaIceLoss:

                                console.log ('Removing sea ice with resolution of', resolution)

                                let iceToRemove = this.checkIceAmount (iceColumns);

                                // The player can't play this card yet
                                if (iceToRemove === 0) {
                                    this.sendBackToDiscard ();
                                }
                                else {
                                    let iceAmount = CARBON_ICE_DESTRUCTION_AMOUNT;

                                    if (resolution === Config.resolutions.rapidSeaIceLoss) { iceAmount = -3 }

                                    iceColumns = this.changeIceAmount (iceAmount, iceColumns);

                                    let cardToFade = discard.splice (state.targetCardIndex, 1) [0]
                                    this.fadeOutCardOutOfPlay (cardToFade, document.querySelector ('.deck.play'))

                                    // splice card out of play
                                    let newState = {
                                        iceColumns,
                                        discard,
                                        animatingCards,
                                        // outOfPlay,
                                        showStopDrawCover: false,
                                    }

                                    // NOT SURE WHY I HAVE TO DO THIS
                                    window.setTimeout (() => {

                                        // newState.discard = discard;
                                        iceColumns = this.checkIceRemovedSurvivors (iceColumns);
                                        newState.iceColumns = iceColumns;

                                        this.setState (newState, () => {

                                            window.setTimeout (async () => {
                                                await this.makeSureCardsBelongToCorrectColumn ()
                                                this.checkIceDependentSpecies ();
                                                // this.setState ({iceColumns})
                                            }, 100)
                                        })
                                    })

                                    return
                                }

                                break;
                            case Config.resolutions.addIce:
                            case Config.resolutions.iceRestoration:
                                let iceAmount = 1;

                                if (resolution === Config.resolutions.iceRestoration) { iceAmount = 2 }

                                iceColumns = this.changeIceAmount (iceAmount, iceColumns);
                                let cardToFade = discard.splice (state.targetCardIndex, 1) [0];
                                this.fadeOutCardOutOfPlay (cardToFade, document.querySelector ('.deck.play'))

                                state.bonusScore += 2

                                iceColumns = this.checkIceRemovedSurvivors (iceColumns);

                                let newState = {
                                    animatingCards,
                                    discard,
                                    iceColumns,
                                    outOfPlay,
                                    bonusScore: state.bonusScore
                                };

                                // NOT SURE WHY I HAVE TO DO THIS
                                window.setTimeout (() => {

                                    this.setState (newState, () => {
                                        window.setTimeout (async () => {
                                            await this.makeSureCardsBelongToCorrectColumn ();
                                            await this.checkIceDependentSpecies ();
                                        }, 100)
                                    });
                                })

                                return
                            case Config.resolutions.protectSpecies:
                                result = this.checkWhichCardToProtect (event);

                                if (!result) { this.sendBackToDiscard (); }
                                else {
                                    iceColumn = iceColumns [result.targetColumnIndex];

                                    // outOfPlay.push (discard.splice (state.targetCardIndex, 1) [0]);
                                    let cardToFadeOut = discard.splice (state.targetCardIndex, 1) [0];
                                    this.fadeOutCardOutOfPlay (cardToFadeOut);

                                    let protectedCard = iceColumn.children [result.targetCardIndex];

                                    iceColumn.children [result.targetCardIndex].isProtected = true;

                                    let newState ={
                                        animatingCards,
                                        discard,
                                        outOfPlay,
                                        iceColumns,
                                        protectedSpeciesName: protectedCard.name
                                     }

                                    let targetCardIndex = state.targetCardIndex;

                                    // NOT SURE WHY I HAVE TO DO THIS
                                    window.setTimeout (() => {
                                        this.setState (newState);
                                    })

                                    return
                                }
                                break;
                            case Config.resolutions.oceanAcid:
                            case Config.resolutions.overHarvesting:
                            case Config.resolutions.invasiveWhales:
                                result = this.checkValidTargetForEvent ();

                                // No valid targets found, send it back to the play area
                                if (!result) { this.sendBackToDiscard () }
                                else {
                                    let targetCards = iceColumns [result.targetColumnIndex].children
                                    let cardToFade = discard.splice (state.targetCardIndex, 1) [0];

                                    let protectedCard = -1;

                                    // console.log (state.protectedSpeciesName, cardToFade.name)

                                    let cardsToFade
                                    if (state.protectedSpeciesName && cardToFade.name === Config.cards.overHarvesting.name) {
                                        console.log ('The cards that are being iterated over', targetCards)
                                        targetCards.forEach ((speciesCard, index) => {
                                            console.log ('Species card name:', speciesCard.name, 'vs the protected species name:', state.protectedSpeciesName)
                                            if (speciesCard.name === state.protectedSpeciesName) {
                                                protectedCard = index;
                                            }
                                        })

                                        console.log ('Was there a protected species in this list?', protectedCard)

                                        // We found a protected card in this stack
                                        if (protectedCard > -1) {
                                            // Prevent playing overharvesting on the top card
                                            if (protectedCard === targetCards.length - 1) {
                                                this.sendBackToDiscard ();
                                                return;
                                            }
                                            // If the protected has stuff stacked on it, then eat those instead
                                            // since anything that eats protected cards can also be over-harvested
                                            else {
                                                // So just remove every card after that card
                                                cardsToFade = targetCards.splice (protectedCard + 1, targetCards.length)
                                            }
                                        }
                                        // We didn't find a protected card, so remove everything
                                        else {
                                            cardsToFade = targetCards.splice (result.targetCardIndex, targetCards.length)
                                        }
                                    }
                                    else {
                                        cardsToFade = targetCards.splice (result.targetCardIndex, targetCards.length)
                                    }

                                    if (cardsToFade && cardsToFade.length) {
                                        cardsToFade.forEach ((crdToFade, index) => {
                                            window.setTimeout (() => {
                                                this.fadeOutCardOutOfPlay (crdToFade)
                                            })
                                        })
                                    }

                                    // outOfPlay.concat (
                                    // )

                                    // outOfPlay.push (discard.splice (state.targetCardIndex, 1) [0]);

                                    this.fadeOutCardOutOfPlay (cardToFade)

                                    let newState = {
                                        animatingCards,
                                        discard,
                                        outOfPlay,
                                        iceColumns,
                                        showStopDrawCover: false
                                    }

                                    // NOT SURE WHY I HAVE TO DO THIS
                                    window.setTimeout (() => {
                                        // this.fadeOutCardOutOfPlay ('discard', discardTargetIndex)
                                        // this.fadeOutCardOutOfPlay ('iceColumns', targetIndex, iceColIndex)

                                        this.setState (newState);
                                    })

                                    return
                                }
                                break;
                            default:
                                console.log ('where did you find this card?');
                                break;
                        }
                    }
                }, async () => {
                    await this.makeSureCardsBelongToCorrectColumn ();
                    await this.checkIceDependentSpecies ();

                });
            }
        }
        else {
            // see if we clicked on a predator card
            if (
                this.state.cardToInspect &&
                this.state.cardToInspect.type === Config.types.apexPredator
            ) {
                // Now check to see if the click event target is within the dom of the card

                let predatorDom = document.getElementById (this.state.cardToInspect.id);

                if (predatorDom && predatorDom.contains (event.target)) {
                    this.onDoubleClick (event)
                }

                this.setState ({ animatingCards: false });
            }
        }

        this.setState ({ isDraggingCard: false });

        // event.stopPropagation ();
        // event.preventDefault ();
    }

    applyScaredClassToCards (worldEventCard, removeScaredClass) {
        if (removeScaredClass === undefined) { removeScaredClass = false; }
        // Don't do anything if the card has no specific target like the ice cards
        if (worldEventCard === null) {
            worldEventCard = { diet: [] }
        }
        else if (worldEventCard.diet.length === 0) { return; }

        var targetCards = worldEventCard.diet
        this.setState ((prevState) => {
            let state = Helper.clone (prevState);
            let iceColumns = state.iceColumns;

            iceColumns.forEach ((iceColumn) => {
                iceColumn.children.forEach ((card) => {

                    if (removeScaredClass === false) {
                        targetCards.forEach ((dietObject) => {
                            if (dietObject.fullName === card.name) { card.isScared = true }
                        })
                    }
                    else {
                        card.isScared = false
                    }
                })
            })

            return { iceColumns, shakingCards: !removeScaredClass }
        })
    }

    fadeOutCardOutOfPlay (crd, parentElement) {
        let card = crd; // store reference in this scope
        if (!card || (card && card.hasStartedFadeAnimation)) { return }

        // let alreadyHasThisCard = false;

        // console.log (fadingOut)
        let fadingOut = Helper.clone (this.state.fadingOut)

        // fadingOut.forEach ((c) => {
        //     if (c != null && card.id === c.id) { alreadyHasThisCard = true; }
        // })

        // console.log ('already has card?', alreadyHasThisCard)

        // if (alreadyHasThisCard) { return }

        // card.hasStartedFadeAnimation = true;
        card.opacity = 1;

        let newParentDom
        let newParentRect
        let cardBoundsUnderOldParent
        let targets

        try {
            newParentDom = document.getElementById ('fade-out');
            newParentRect = newParentDom.getBoundingClientRect ();
            cardBoundsUnderOldParent = document.getElementById (card.id).getBoundingClientRect ();
            targets = {}
            targets.x = cardBoundsUnderOldParent.x - newParentRect.x;
            targets.y = cardBoundsUnderOldParent.y - newParentRect.y;
        }
        catch (error) {
            console.clear ();
            console.log (error);
            console.log ('Card that caused a problem:', card)
            console.log ('Looking for card with an ID of', card.id);
            console.log (document.getElementById (card.id))
            return;
        }

        // console.clear ();
        // console.log ('Gathering stuff to move card into position');
        // console.log (newParentDom)
        // console.log (newParentRect)
        // console.log (targets)
        // console.log (cardBoundsUnderOldParent)

        card.position = targets;
        fadingOut.push (card);
        let cardIndex = fadingOut.length - 1;

        let newState = {};

        newState.fadingOut = fadingOut;

        this.setState (newState, () => {
            anime ({
                targets: [card],
                opacity: 0,
                delay: 1,
                duration: FADE_OUT_TIME,
                ease: 'easeOutExpo',
                update: (anim) => {
                    window.setTimeout (() => {
                        this.setState ((prevState) => {
                            let state = Helper.clone (prevState);
                            let fadingOut = state.fadingOut;

                            fadingOut.forEach ((c, index) => {
                                if (c != null && c.id === card.id) {
                                    c.opacity = 1 - (anim.progress / 100)
                                    // console.log ('setting card opacity to', c.opacity)
                                    fadingOut [index] = c;
                                }
                            })

                            return { fadingOut }
                        })
                    })
                },
                complete: () => {
                    window.setTimeout (() => {
                        this.setState ((prevState) => {
                            let state = Helper.clone (prevState);
                            let fadingOut = state.fadingOut;
                            let filteredFadingOut = [];

                            filteredFadingOut = fadingOut.filter ((c) => {
                                return c.opacity != 0;
                            })

                            return { fadingOut: filteredFadingOut }
                        })
                    })
                }
            })
        })
    }

    // ---
    // ---
    // ---
//      Find Functions
    // ---
    // ---
    // ---

    // Looks through the discard and columns depending on currently set card parent
    findCard (prevState) {
        let state = this.state;

        if (prevState) { state = prevState }

        let card;

        if (state.cardParent === 'discard') {
            card = state.discard [state.targetCardIndex];
        }
        else {
            // find what column has this card
            let column, columnIndex;

            state.iceColumns.forEach ((col, index) => {
                if (col.id === state.cardParent) {
                    column = col;
                    columnIndex = index;
                }
            })

            card = column.children [state.targetCardIndex];
        }

        return card;
    }

    findClosestColumn (cardCenter, columnACenter, columnBCenter) {
        // subtract the cardCenter from the other two cards
        // whichever result is closer to zero is the closer column

        let colAResult = Math.abs (columnACenter - cardCenter);
        let colBResult = Math.abs (columnBCenter - cardCenter);

        if (colAResult < colBResult) { return 1 }
        else if (colBResult < colAResult) { return 2 }
        else if (colAResult === colBResult) { return Math.ceil (Math.random () * 2) }
    }

    // ---
    // ---
    // ---
//      Check Functions
    // ---
    // ---
    // ---

    checkIceRemovedSurvivors (iceColumns) {
        // iterate over ice columns
        // remove any ice algea on water and remove any phyto plankton on ice
        let iceAmount = this.checkIceAmount (iceColumns);

        let columns = Helper.clone (iceColumns);
        columns.forEach ((column, colIndex) => {
            let ice = column.ice;
            let hasAlgea = false;
            let hasPlankton = false;

            if (column.children.length) {
                if (column.children [0].name === Config.cards.iceAlgea.name ) { hasAlgea = true }
                else if (column.children [0].name === Config.cards.phytoPlankton.name) { hasPlankton = true }
                // console.log (column.children)
                // console.log ('Column', column.id, 'has children?', column.children.length, 'and needs to remove children?', ice != hasAlgea)

                // iterate over the children and remove specific children
                let item, key;
                for (key in column.children) {
                    item = column.children [key];

                    // console.log ('checking: ', item.name, 'which needs', item.needsIce, 'ice and there is', iceAmount, 'ice left')
                    if (item.needsIce > iceAmount) {
                        let result = Helper.clone (column.children);
                        result.forEach ((crdToFade) => {
                            // window.setTimeout (() => {
                                this.fadeOutCardOutOfPlay (crdToFade)
                            // })
                        })

                        window.setTimeout (() => {
                            column.children.splice (Number (key), 10);
                            //     column.children.splice (Number(key), 10)
                            // }, FADE_OUT_TIME)
                        })
                        break;
                    }

                }

                if (
                    (!ice && hasAlgea) ||
                    (ice && hasPlankton)
                ) {
                    if (column.children.length) {
                        let cardsToFade = Helper.clone (column.children);
                        cardsToFade.forEach ((crdToFade, index) => {
                            this.fadeOutCardOutOfPlay (crdToFade)
                            // window.setTimeout (() => {
                            // })
                        })
                    }

                    window.setTimeout (() => {
                        column.children = []

                    })
                }
            }
        })

        return columns;
    }

    checkForCollision (cardDom, columnDom) {
        let cardBounds = cardDom.getBoundingClientRect ();
        let cardWidth = cardDom.clientWidth;
        let columnBounds = columnDom.getBoundingClientRect ();
        let columnWidth = columnDom.clientWidth;

        // console.log ('Checking for collision between', cardDom, 'and', columnDom)

        if (
            cardBounds.right > columnBounds.x &&
            cardBounds.x < columnBounds.right
        ) {
            return { cardBounds, cardWidth, columnBounds, columnWidth }
        }
    }

    checkIceAmount (iceColumns) {
        let amountOfIce = 0;

        iceColumns.forEach ((column) => { if (column.ice === true) { amountOfIce++ } })

        return amountOfIce
    }

    // Overloading this functions responsibilities for the sake of time
    checkIceDependentSpecies () {
        this.setState ((prevState) => {
            // get ice amount
            let state = Helper.clone (this.state);
            let iceColumns = state.iceColumns;
            let iceAmount = this.checkIceAmount (iceColumns);

            // Iterate over ice columns and splice out any animals that need
            // more ice than what is available
            iceColumns.forEach ((column, colIndex) => {

                // console.log ('CHECKING ICE COLUMN????')

                let earliestIndex = null;
                column.children.forEach ((child, index) => {
                    // console.log (child.name, '===', Config.cards.phytoPlankton.name, '?', 'and column is ice?', column.ice)
                    // console.log ('Looking at', child.name, 'that needs', child.needsIce, 'ice to live')
                    if (child.needsIce > iceAmount && earliestIndex === null) {
                        earliestIndex = index;
                    }
                    else if (child.name === Config.cards.phytoPlankton.name && column.ice === true) {
                        earliestIndex = -1
                    }
                    else if (child.name === Config.cards.iceAlgea.name && column.ice === false) {
                        earliestIndex = -1
                    }
                })

                // console.log ('FOUND AN EARLIEST INDEX?', earliestIndex)

                if (earliestIndex != null) {
                    // let end = column.children.length - 1;
                    // Need to iterate backwards because fadeOutFunction splices cards from columns
                    // for (let i = end; i >= earliestIndex; i--) {
                    //     console.log ('!!!')
                    //     console.log ('fading out card...', i)
                    //     console.log ('!!!')
                    //     this.fadeOutCardOutOfPlay ('iceColumns', i, colIndex)
                    // }

                    let cardsToFade = Helper.clone (column.children);

                    column.children.splice (earliestIndex, column.children.length);

                    cardsToFade.forEach ((crdToFade, index) => {
                        if (index >= earliestIndex) {
                            window.setTimeout (() => {
                                this.fadeOutCardOutOfPlay (crdToFade)
                            })
                        }
                    })
                }
            })

            return { iceColumns }
        }, () => {
            this.setState ((prevState) => {
                let iceColumns = Helper.clone (prevState.iceColumns)
                iceColumns = this.checkIceRemovedSurvivors (prevState.iceColumns);

                return { iceColumns }
            })
        })
    }

    // checkIfAnimalsNeedIce (iceColumns) {
    //     let amountOfIce = this.checkIceAmount (iceColumns);
    //
    //     iceColumns.forEach ((column) => {
    //         let killIndex = 99;
    //         // Iterate over cards in column and look for any
    //         // cards that can't live anymore
    //         column.children.forEach ((child, index) => {
    //             // Remove the earliest match in the chain
    //             if (
    //                 child.needsIce > amountOfIce &&
    //                 killIndex > index
    //             ) {
    //                 killIndex = index;
    //             }
    //         })
    //
    //         //Send those cards to the shadow realm
    //         column.children.splice (killIndex, column.children.length);
    //     })
    //
    //     return iceColumns;
    // }

    checkIfCardCanGoInColumn (crd) {
        //find where our card is
        let card = this.findCard ();

        if (crd) { card = crd }

        // Do nothing if no card is found
        if (!card) { return }

        let iceAmount = this.checkIceAmount (this.state.iceColumns);

        console.log ('Card that is being moved:', card);

        let cardDom = document.querySelector ('#' + card.id);

        let collisions = [];

        this.state.iceColumns.forEach ((iceColumn, index) => {
            let columnDom = document.querySelector ('#' + iceColumn.id);

            let collision = this.checkForCollision (cardDom, columnDom)
            if (collision) {
                collision.iceColumnIndex = index;
                collisions.push (collision)
            }
        })

        let selectedColumn = null;

        if (collisions.length === 1) {
            // Don't bother checking for most matched column,
            //just use the one that was collided with
            selectedColumn = collisions [0];
        }
        else if (collisions.length > 1) {
            // compare every collision against each other
            // to see which column the card is most over
            // ...though I'm not sure that a card is large
            // enought to cover more than 2 columns, but still...

            // for now, just assume that only two collisions are happening
            let cardCenter = collisions [0].cardBounds.x + (collisions [0].cardWidth / 2);
            let columnACenter = collisions [0].columnBounds.x + (collisions [0].columnWidth / 2);
            let columnBCenter = collisions [1].columnBounds.x + (collisions [1].columnWidth / 2);
            let result = this.findClosestColumn (cardCenter, columnACenter, columnBCenter);

            if (result === 1) { selectedColumn = collisions [0] }
            else if (result === 2) { selectedColumn = collisions [1] }
        }

        // Now that we have the closest match
        // See if that card can even go into that column
        // ...
        if (card.needsIce > iceAmount) { return false }

        if (selectedColumn) {

            // Finally return the result
            return selectedColumn
        }
    }

    checkIfFeedingPredator (card, event) {
        console.log ('Checking for viable predator targets')
        // iterate over apex predator doms
        let predatorDoms = [
            document.getElementById (APEX_PREDATOR_SLOT_ID_ZERO),
            document.getElementById (APEX_PREDATOR_SLOT_ID_ONE),
            document.getElementById (APEX_PREDATOR_SLOT_ID_TWO),
            document.getElementById (APEX_PREDATOR_SLOT_ID_THREE),
        ]

        // don't bother checking doms that don't have predators
        if (this.state.drawnApexPredators.length < 4) {
            let start = this.state.drawnApexPredators.length;
            let end = 4;

            console.log ('splicing from', start)

            predatorDoms.splice (start, end);
        }

        // console.log (predatorDoms)

        // If there are no predators to check against, then don't do the rest
        if (predatorDoms.length === 0) { return null }

        let cardDom = document.getElementById (card.id);

        let inDiet = false;

        let crd = card;
        if (this.state.otherCardsBeingDragged.length > 0) {
            let cardParent = this.state.cardParent;
            let iceCols = this.state.iceColumns
            let iceCol

            iceCols.forEach ((col) => { if (col.id === cardParent) { iceCol = col; } })

            crd = iceCol.children [iceCol.children.length - 1]
            console.log ('Top card:',crd)
        }

        // Iterate over doms and check for a collision
        let collision, closestCollision, colIndex;
        predatorDoms.forEach ((dom, index) => {
            collision = this.checkForMouseCollision (event, dom)

            if (!closestCollision) {
                closestCollision = collision;
                colIndex = index;

                console.log (this.state.drawnApexPredators [index])

                // Also check to see if the predator can eat this animal
                if (
                    this.state.drawnApexPredators [index] &&
                    this.state.drawnApexPredators [index].diet
                ) {
                    this.state.drawnApexPredators [index].diet.forEach ((species) => {
                        console.log ('comparing', species.fullName, 'to', crd.name)
                        if (species.fullName === crd.name) { inDiet = true }
                    })
                }
            }
        })

        if (inDiet) {
            return {closestCollision, colIndex}
        }
        else {
            return false
        }
    }

    checkForMouseCollision (mouseEvent, dom) {
        let mouseX = mouseEvent.pageX;
        let mouseY = mouseEvent.pageY;

        let domBounds = dom.getBoundingClientRect ();

        let withinX = (mouseX > domBounds.left && mouseX < domBounds.right);
        let withinY = (mouseY > domBounds.top && mouseY < domBounds.bottom)

        return (withinX && withinY)
    }

    checkIfSpeciesCanGoInColumn (card, column) {
        // Look at the top most child to see if the card being dropped can eat
        // that card, if there are no children, check if this card needs ice
        // if that card needs ice, iterate over all the ice columns to see
        // if enough ice exists

        // console.log (card.name, Config.cards.iceAlgea.name)

        if (column.children.length) {
            let children = column.children;
            let topChild = children [children.length - 1];
            // console.log ('check one')

            let eatsThatAnimal = false;

            card.diet.forEach ( (item) => {
                if (item.name === topChild.symbol) { eatsThatAnimal = true }
            })

            return eatsThatAnimal;
        }
        else if (card.needsIce > 0 && card.diet.length === 0 && card.name != Config.cards.iceAlgea.name) {
            let columns = this.state.iceColumns

            // console.log ('check two')

            let currentIce = this.checkIceAmount ();

            return currentIce >= card.needsIce
        }
        else if (column.children.length === 0) {
            // check to see if this is phyto plankton or ice algea
            // Ice algea can only go on ice and phyto plankton can only go on water

            if (card.name !== Config.cards.iceAlgea.name &&
                card.name !== Config.cards.phytoPlankton.name
            ) { return false }

            let isIceAlgea = false;

            if (card.name === Config.cards.iceAlgea.name) {
                isIceAlgea = true;
            }

            // console.log ('Trying to put', card.name, 'in a frozen column?', column.ice)

            return ( isIceAlgea === column.ice );
        }
        else if (card.diet.length === 0 && card.needsIce === 0) {
            // console.log ('Check four')
            return true
        }
    }

    checkValidTargetForEvent (crd) {
        // Looks at the column the whale was dropped in and if it has
        // any of the valid targets to hunt
        let result = false;

        let eventCard = this.findCard ();

        let columnCheck = false;

        if (eventCard) {
            columnCheck = this.checkIfCardCanGoInColumn (eventCard);
        }

        let iceColumnIndex
        let lowestIndex = 9999;
        // We are dragging and dropping a card
        if (columnCheck) {
            if (crd && !eventCard) { eventCard = crd; }
            if (!crd && !eventCard) { return result; }

            iceColumnIndex = columnCheck.iceColumnIndex;

            let iceColumn = this.state.iceColumns [iceColumnIndex]

            if (eventCard.validTargets === undefined) { return result }

            if (iceColumn && iceColumn.children.length) {
                iceColumn.children.forEach ((child, index) => {
                    if (eventCard && eventCard.validTargets) {
                        eventCard.validTargets.forEach ((validTargetName) => {
                            if (child.name === validTargetName && index < lowestIndex) {
                                lowestIndex = index
                            }
                        })
                    }
                })
            }
        }
        // This is a check across every ice column
        else {
            let iceColumns = this.state.iceColumns
            eventCard = crd;

            iceColumns.forEach ((iceColumn) => {
                iceColumn.children.forEach ((child, index) => {
                    if (eventCard && eventCard.validTargets) {
                        eventCard.validTargets.forEach ((validTargetName) => {
                            if (child.name === validTargetName && index < lowestIndex) {
                                lowestIndex = index
                            }
                        })
                    }
                })
            })
        }


        if (lowestIndex !== 9999) {

            result = {
                targetColumnIndex: iceColumnIndex,
                targetCardIndex: lowestIndex
            }
        }

        return result
    }

    // Looks for which card the "Protect a Species" card is most
    // on top of
    checkWhichCardToProtect (event) {
        let result = false;
        // Get our card, which we already know is our protect-a-species card
        let card = this.findCard ();
        // See which column this card is going to land it
        let targetColumnIndex = this.checkIfCardCanGoInColumn ().iceColumnIndex
        let column = this.state.iceColumns [targetColumnIndex];

        if (column && column.children.length) {
            // The discard deck is always a fixed position from the top of the screen
            // So offset... should probably update this in the future but time in sparse atm
            let targetY;

            if (event && event.pageY) { targetY = event.pageY - 120; }
            else { targetY = card.position.y + 350; }

            let closestY = 9999;
            let closestIndex = null;
            let y;

            // Iterate over children of that column
            column.children.forEach ( (child, index) => {
                // 35 pixels is about the height of overlap on a card
                // this also assumes we are getting out Y from the mouse
                y = Math.abs ((child.position.y + 35) - targetY);

                if (y < closestY) {
                    closestY = y;
                    closestIndex = index;
                }
            })

            result = {
                targetColumnIndex,
                targetCardIndex: closestIndex,
                targetCard: column.children [closestIndex]
            }

            let validCard = false;
            Config.cards.protectASpecies.validTargets.forEach ((name) => {
                if (name === result.targetCard.name) { validCard = true; }
            })

            if (!validCard) { result = false }
        }

        return result
    }

    // ---
    // ---
    // ---
//      Rendering Functions
    // ---
    // ---
    // ---

    collectIceColumnDomRef (index, dom) { this._iceColumnDoms [index] = dom; }

    createIceColumn (item, index) {
        // console.log ('Rendering ice columns with protected species name:', this.state.protectedSpeciesName)
        return (
            <IceColumn
                id={item.id}
                ref={(dom) => { this.collectIceColumnDomRef (index, dom); }}
                ice={item.ice}
                onMouseDownOnCard={this.onMouseDownOnCard}
                protectedSpeciesName={this.state.protectedSpeciesName}
                // onDoubleClick={this.onDoubleClick}
            >
                {item.children}
            </IceColumn>
        )
    }

    renderFadingOutCards (data, index) {
        if (data === null) {
            return (<span></span>)
        }

        // console.log ('Rendering card with an opacity of:', data.opacity)

        return (
            <Card
                key={index}
                id={data.id}
                name={data.name}
                img={data.img}
                zIndex={data.zIndex}
                isActive={data.isActive}
                position={data.position}
                isFaceDown={data.isFaceDown}
                isDiscarded={data.isDiscarded}
                isPlacedInColumn={data.isPlacedInColumn}
                isProtected={data.isProtected}
                type={data.type}
                index={index}
                diet={data.diet}
                iceDestroyed={data.iceDestroyed}
                symbol={data.symbol}
                facts={data.facts}
                trophicLevel={data.trophicLevel}
                needsIce={data.needsIce}
                validTargets={data.validTargets}
                footer={data.footer}
                blockerText={data.blockerText}
                opacity={data.opacity}

                onMouseDown={() => {}}
                protectedSpeciesName={() => {}}
            />
        )
    }

    startTour () {
        window.startTour ();
    }

    render () {
        let leftColumnElements, rightColumnElements

        let stopDrawCover = (
            <div>
                {this.state.showStopDrawCover === true &&
                    <div className="stop-drawing-cards">
                        {   ('blockerText' in this.state.stopperCard) &&
                            this.state.stopperCard.blockerText.length > 0 &&
                            <p>{this.state.stopperCard.blockerText}</p>
                        }
                        {   (!('blockerText' in this.state.stopperCard) ||
                            this.state.stopperCard.blockerText.length === 0) &&
                            <p>Event card must be played to continue</p>
                        }
                    </div>
                }
            </div>
        )

        let deck = (
            <Deck
            name="Draw"
            onClick={this.flipAndMoveCard} protectedSpeciesName={this.state.protectedSpeciesName}
            >
                { this.state.deck }
            </Deck>
        )

        let discardDeck = (
            <Deck
                name="Play"
                onMouseDownOnCard={this.onMouseDownOnCard}
                iceDestroyed={this.state.iceDestroyed}
                protectedSpeciesName={this.state.protectedSpeciesName}
                // onDoubleClick={this.onDoubleClick}
            >
                { this.state.discard }
            </Deck>
        )

        let predatoryMammalSlots = (
            <div className="apex-card-holder">

                <div className="header-bar">
                    <p>Hunters</p>
                </div>

                <div className="apex-card-row">
                    <ApexCardSlot
                        id={APEX_PREDATOR_SLOT_ID_ZERO}
                        // onDoubleclick={this.onDoubleclick}
                        onMouseDownOnCard={this.onMouseDownOnCard}
                        givenFoodChain={this.state.apexPredatorFoodChains.zero}
                    >
                        {this.state.drawnApexPredators [0]}
                    </ApexCardSlot>
                    <ApexCardSlot
                        id={APEX_PREDATOR_SLOT_ID_ONE}
                        // onDoubleclick={this.onDoubleclick}
                        onMouseDownOnCard={this.onMouseDownOnCard}
                        givenFoodChain={this.state.apexPredatorFoodChains.one}
                    >
                        {this.state.drawnApexPredators [1]}
                    </ApexCardSlot>
                </div>
                <div className="apex-card-row">
                    <ApexCardSlot
                        id={APEX_PREDATOR_SLOT_ID_TWO}
                        // onDoubleclick={this.onDoubleclick}
                        onMouseDownOnCard={this.onMouseDownOnCard}
                        givenFoodChain={this.state.apexPredatorFoodChains.two}
                    >
                        {this.state.drawnApexPredators [2]}
                    </ApexCardSlot>
                    <ApexCardSlot
                        id={APEX_PREDATOR_SLOT_ID_THREE}
                        // onDoubleclick={this.onDoubleclick}
                        onMouseDownOnCard={this.onMouseDownOnCard}
                        givenFoodChain={this.state.apexPredatorFoodChains.three}
                    >
                        {this.state.drawnApexPredators [3]}
                    </ApexCardSlot>
                </div>
            </div>
        )

        switch (Config.layout) {
            case 1:
                leftColumnElements = [stopDrawCover, deck, discardDeck]
                rightColumnElements = [predatoryMammalSlots]
                break;
            case 2:
                leftColumnElements = [predatoryMammalSlots]
                rightColumnElements = [stopDrawCover, deck, discardDeck]
                break;
            default:
                console.warn ('Unsupported config layout detected')
        }

        let totalScore = this.state.speciesScore + this.state.iceScore + this.state.bonusScore;

        return (
            <div className="eco-chains">
                <div className="ice-image-left"></div>
                <div className="ice-image-right"></div>
                <div className="top row">
                    <div className="left column">
                        <div className="header">
                            <div className="logo"></div>
                            <div className="divider"></div>
                            <div className="title">Arctic Futures</div>
                        </div>
                    </div>
                    <div className="middle column">
                        <div className="help">
                            <div className="quickstart-guide" onClick={ () => { try { window.startTour (); } catch (error) { console.error (error) } } }>
                                <img src="./play-circle.svg" />
                                <span>Quickstart Guide</span>
                            </div>
                            <a href="https://etx-nec.s3-us-west-2.amazonaws.com/css/etx/projects/ecochains/how-to-play/index.html" target="_blank">
                                <div className="instructions">
                                    <img src="./doc.svg" />
                                    <span>Instructions</span>
                                </div>
                            </a>
                        </div>
                        <div className="scores">
                            <ScoreKeeper label="Species" score={this.state.speciesScore}/>
                            <ScoreKeeper label="Ice" score={this.state.iceScore}/>
                            <ScoreKeeper label="Action" score={this.state.bonusScore}/>
                        </div>
                    </div>
                    <div className="right column">
                        <ScoreKeeper type="total" label="Total Score:" score={ this.state.speciesScore + this.state.iceScore + this.state.bonusScore }/>
                        {this.state.hideHelpButton === false &&
                            <button class="help-button" onClick={this.startTour}> Help </button>
                        }

                    </div>

                </div>

                <div className="middle row">
                    <div className="left column">
                        <div className="background"></div>
                        { leftColumnElements }
                    </div>
                    <div className="center column">
                        <div className="header-bar"><p>Environment</p></div>
                        { this.state.iceColumns.map ( this.createIceColumn ) }
                    </div>
                    <div className="right column">
                        { rightColumnElements }
                    </div>
                </div>

                {this.state.deck.length === 0 &&
                 this.state.showEndGameScreen === false &&
                    <div
                        className="end-game-button flash"
                        onClick={this.endGame}
                    >
                    <p>
                        FINISH GAME
                    </p>
                    </div>
                }

                <div id="fade-out" style={{position: 'absolute', top: 0, left: 0}}>
                    {this.state.fadingOut.map (this.renderFadingOutCards)}
                </div>

                {this.state.showInspectionModal === true &&
                    <CardModal
                        card={this.state.cardToInspect}
                        onClick={this.closeModal}
                    />
                }

                {this.state.showEndGameScreen === true &&
                    <div className="end-game-modal">
                        <div className="overlay">
                            <div className="end-game-modal-content">
                                <div className="modal-head">
                                    Final results
                                </div>

                                <div className="modal-body">
                                    <div className="ranks">
                                        <div class="title">
                                            <p>Points & Ranks</p>
                                        </div>
                                        <div class="results">
                                            <p>{'<'} 20 Keep trying!</p>
                                            <p>20-29 Competent</p>
                                            <p>30-39 Expert</p>
                                            <p>40+ Rescuer</p>
                                        </div>
                                    </div>
                                    <div className="player-rank">
                                        <p>Your rank...</p>
                                    </div>
                                    <div class="player-scores">
                                        <ScoreKeeper label="Species" score={this.state.speciesScore}/>
                                        <ScoreKeeper label="Ice" score={this.state.iceScore}/>
                                        <ScoreKeeper label="Action" score={this.state.bonusScore}/>
                                    </div>
                                    <div className="final-score">
                                        <ScoreKeeper type="total" label="Total Score" score={ this.state.speciesScore + this.state.iceScore + this.state.bonusScore }/>
                                    </div>
                                    <div>

                                        <div className="player-rank">
                                            {totalScore < 20 &&
                                                <h1>Keep trying!</h1>
                                            }
                                            {totalScore < 30 &&
                                            totalScore >= 20 &&
                                                <h1>Competent</h1>
                                            }
                                            {totalScore < 40 &&
                                            totalScore >= 30 &&
                                                <h1>Expert</h1>
                                            }
                                            {totalScore >= 40 &&
                                                <h1>Rescuer</h1>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <div
                                        className="new-game-button"
                                        onClick={this.newGame}
                                    >
                                        <p>New Game</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </div>
        )
    }
}
